// removed by extract-text-webpack-plugin
module.exports = {"title":"_2nkyXShKxKmn_-qJmCc-fN","buttonNew":"_1oMdeBaYrZCuT2TATA9xvq","searchField":"_17GVcp-LWyt3l3TqVPBG71","buttonLoadMore":"_1uJ1ophU13nsT2ng9g1XGy","spinner":"QHYtOVySJAc9TDJvMgqm9"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Bundles/style.scss
// module id = 1244
// module chunks = 0